import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell, Checkbox } from '@mui/material';

const RequiredDocTypeComponentItem = ({ item, onToggleSelectItem }) => (
  <TableRow>
    <TableCell size={'small'}>
      <Checkbox
        id={`requiredDocType_selected${item.id}`}
        checked={item.selected || false}
        onChange={() => onToggleSelectItem(item.id, item.contextName)}
      />
    </TableCell>
    <TableCell>{item.documentName}</TableCell>
    <TableCell>{item.contextName}</TableCell>
  </TableRow>
);

RequiredDocTypeComponentItem.propTypes = {
  item: PropTypes.object.isRequired,
  onToggleSelectItem: PropTypes.func.isRequired
};

export default RequiredDocTypeComponentItem;
